import { authControllerGetCurrentUser } from "@/lib/lutely-api/gen/auth/auth";
import { hasSellerPersona } from "@/lib/personas";

/**
 * Artists and label reps always land on their workspace after logging in.
 * Fetches the freshly-authenticated user and returns the Artists roster for
 * a label (two or more artists), "/audiolab" for any other seller persona,
 * otherwise null (callers fall back to their normal redirect logic). Never
 * throws — a failed fetch resolves to null.
 */
export async function getPersonaLandingPath(): Promise<string | null> {
  try {
    const me = await authControllerGetCurrentUser();
    if ((me.creators?.length ?? 0) >= 2) {
      return "/audiolab/roster";
    }
    if (hasSellerPersona(me.profile?.personas)) {
      return "/audiolab";
    }
  } catch {
    // Ignore — fall back to default redirect behavior.
  }
  return null;
}
